'use client';

import dynamic from 'next/dynamic';

const ChatWidgetsInner = dynamic(() => import('./ChatWidgetsInner'), {
  ssr: false,
});

export default function ChatWidgets() {
  return <ChatWidgetsInner />;
}
